<!--
Copyright (C) 2020 GanttProject Cloud OU
Author: Dmitry Barashev

This is a progress indicator component. Currently the only supported type is spinner (indeterminate progress indicator)
-->
<template>
  <div class="glasspane" :id="id">
    <div class="d-flex justify-content-center align-items-center fa-4x h-100">
      <div><i class="fa fa-spin fa-spinner"></i></div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-facing-decorator';
import FadingElement from '@/utils/FadingElement';

@Component
export default class ProgressIndicator extends Vue {
  @Prop public type: string;
  @Prop public id: string;

  private glasspane?: FadingElement = undefined;

  toggle(on: boolean) {
    if (this.glasspane === undefined) {
      this.glasspane = new FadingElement(`#${this.id}`, 0.7, false);
    }
    this.glasspane.toggle(!on);
  }

}
</script>

<style scoped>
.glasspane {
  background-color: whitesmoke;
}
</style>
